import {
  tableHeaderOrientationOptions,
  tableHeaderTypeOptions
} from '../../constants.js'
import { HeaderContainer, HeaderText } from './styled-components.js'
import CheckboxComponent from '../../../../atoms/checkboxes/index.jsx'
import { Confirm } from '../../../../atoms/icons/essentials/index.js'
import { checkboxSizeOptions } from '../../../../atoms/checkboxes/constants.js'
import {
  DragNDrop,
  SortDownOrange,
  SortUpDown,
  SortUpOrange
} from '../../../../atoms/icons/table/index.jsx'
import { flexRender } from '@tanstack/react-table'
import { iconSizeOptions } from '../../../../atoms/icons/icons-sizes.js'

const TableHeaderCell = ({
  table,
  header,
  type = tableHeaderTypeOptions.TEXT,
  orientation = tableHeaderOrientationOptions.LEFT,
  showIcon = true,
  sorting,
  disabled,
  ...props
}) => {
  const columnMeta = header.column.columnDef.meta ?? {}
  const headerMeta = columnMeta.header ?? columnMeta
  const columnType = headerMeta.type || type
  const columnOrientation = headerMeta.orientation || orientation
  const columnCheckboxSize =
    headerMeta.checkbox?.size ?? columnMeta.checkboxSize
  const columnShowIcon = headerMeta.showIcon ?? showIcon

  // Verify if the column can be sort
  const isSortable = header.column.getCanSort()

  // Sorting handler
  const sortHandler = header.column.getToggleSortingHandler()

  if (columnType === tableHeaderTypeOptions.EMPTY) {
    return (
      <HeaderContainer
        orientation={columnOrientation}
        {...props}
        disabled={disabled}
      />
    )
  }

  if (columnType === tableHeaderTypeOptions.TEXT) {
    const handleOnClick = () => {
      if (!disabled && isSortable) sortHandler()
    }

    return (
      <HeaderContainer
        orientation={columnOrientation}
        onClick={handleOnClick}
        disabled={disabled}
        {...props}
      >
        <HeaderText
          sortDirection={header.column.getIsSorted()}
          disabled={disabled}
        >
          {flexRender(header.column.columnDef.header, header.getContext())}
          {!disabled && isSortable && (
            <>
              {{
                asc: <SortUpOrange size={iconSizeOptions['ICON-S']} />,
                desc: <SortDownOrange size={iconSizeOptions['ICON-S']} />
              }[header.column.getIsSorted()] ?? (
                <SortUpDown size={iconSizeOptions['ICON-S']} />
              )}
            </>
          )}
        </HeaderText>
      </HeaderContainer>
    )
  }

  if (columnType === tableHeaderTypeOptions.CHECKBOX) {
    if (!columnCheckboxSize) {
      throw new Error(
        `Table checkbox headers require meta.header.checkbox.size. Valid sizes: ${Object.values(
          checkboxSizeOptions
        ).join(', ')}.`
      )
    }

    return (
      <HeaderContainer
        orientation={columnOrientation}
        {...props}
        disabled={disabled}
      >
        <CheckboxComponent.Root
          forceInput
          size={columnCheckboxSize}
          checked={table.getIsAllRowsSelected()}
          customOnClick={table.getToggleAllRowsSelectedHandler()}
          disabled={disabled}
        >
          <CheckboxComponent.Indicator>
            <Confirm size={iconSizeOptions['ICON-S']} />
          </CheckboxComponent.Indicator>
        </CheckboxComponent.Root>
      </HeaderContainer>
    )
  }

  if (columnType === tableHeaderTypeOptions.HANDLE) {
    return (
      <HeaderContainer
        orientation={columnOrientation}
        {...props}
        disabled={disabled}
      >
        {columnShowIcon && <DragNDrop size={iconSizeOptions['ICON-S']} />}
      </HeaderContainer>
    )
  }

  return <HeaderContainer {...props} disabled={disabled} />
}

export default TableHeaderCell
